import classNames from 'classnames';
import queryString from 'query-string';
import { useSearch } from 'wouter';

import useFiltersQuery from '../../hooks/useFiltersQuery';
import useScrollEnter from '../../hooks/useScrollEnter';
import { usePageViewTracking } from '../../hooks/useTracking';

import { typesSections } from '../../routes';
import HeaderAd from '../ads/HeaderAd';
import IndexDefaultHeader from '../headers/IndexDefaultHeader';
import InfiniteItemsBlocks from '../lists/InfiniteItemsBlocks';
import TypesMenu from '../menus/TypesMenu';

import styles from '../../styles/pages/section-page.module.css';

interface SectionPageDefaultProps {
    brand: Brand;
    type?: string | null;
    section: Section;
    current?: boolean;
    className?: string | null;
    contentClassName?: string | null;
    onEnter?: () => void;
    onLeave?: () => void;
}

function SectionPageDefault({
    brand,
    type: typeSlug = null,
    section,
    current,
    className,
    contentClassName,
    onEnter,
    onLeave,
}: SectionPageDefaultProps) {
    const type = typesSections.find(({ id, path }) => id === typeSlug || path === typeSlug);
    const { query: typeQuery } = type || {};
    const { handle: brandHandle = null } = brand || {};

    const { id: sectionId = null, label } = section || {};
    const filters = useFiltersQuery();
    const search = useSearch();
    const { sort = null } = queryString.parse(search);

    useScrollEnter({
        disabled: !current,
        onEnter,
        onLeave,
    });

    usePageViewTracking(current, {
        brand,
        section,
        pageType: 'section',
    });

    return (
        <div
            className={classNames([styles.container, className, contentClassName])}
            data-brand={brandHandle}
        >
            <HeaderAd />
            <IndexDefaultHeader title={label} />
            <TypesMenu
                brand={brand}
                parent={section}
                sort={sort}
                withSort
                withParent
                className={styles.filters}
            />
            <main>
                {sectionId !== null ? (
                    <InfiniteItemsBlocks
                        query={{
                            section: sectionId,
                            ...typeQuery,
                            ...filters,
                        }}
                        cardWithout={['category']}
                        cardWith={['brand-icon']}
                    />
                ) : null}
            </main>
        </div>
    );
}

export default SectionPageDefault;
